import React, { useEffect, useState } from 'react'
import { GlobalContext } from "../../Context/Context"
import { getBaseUrl } from "../../Services/HttpService"

const RightAddComponent = () => {
    const context = React.useContext(GlobalContext)
    let adds = context.common.adds
    const [rightAdds, setRightAdds] = useState([])
    useEffect(() => {
        let rightArray = adds.filter(add => (add.AdPosition === "right" && add.AdStatus === "Active"));
        if (rightArray.length) {
            let testAr=[...rightArray]
            testAr.sort(function(a, b) {
                return a.OrderNumber - b.OrderNumber;
            });
            setRightAdds(testAr)
        }
    }, [])
    // console.log(rightAdds,'right adds')
    return (rightAdds.map((add_) => {
        return (<div className="Adv_box mb-2">
            <a href={add_.AdLink} target="_blank">
                <img
                    src={getBaseUrl() + "/advertisementfiles/" + add_.AdImageVideo}
                    alt="adv" />
            </a>
        </div>)
    })

    )
}
export default RightAddComponent




